import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('customer_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const url = err.config?.url || '';
      // 로그인/회원가입 요청이나 백그라운드 API는 로그아웃 처리하지 않음
      const skipLogout = url.includes('/auth/') || url.includes('/unread');
      if (!skipLogout && localStorage.getItem('customer_token')) {
        localStorage.removeItem('customer_token');
        localStorage.removeItem('customer_user');
        window.location.href = '/';
      }
    }
    return Promise.reject(err);
  }
);

export const customerAuthAPI = {
  register: (data) => api.post('/customer/auth/register', data),
  login: (data) => api.post('/customer/auth/login', data),
  me: () => api.get('/customer/auth/me'),
  updateMe: (data) => api.put('/customer/auth/me', data),
  changePassword: (data) => api.put('/customer/auth/password', data),
  sendEmailOtp: (email) => api.post('/customer/auth/email-otp/send', { email }),
  verifyEmailOtp: (email, code) => api.post('/customer/auth/email-otp/verify', { email, code }),
};

export const customerOrdersAPI = {
  getAll: () => api.get('/customer/orders'),
  getOne: (id) => api.get(`/customer/orders/${id}`),
  create: (formData) => api.post('/customer/orders', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  getAccountInfo: () => api.get('/customer/orders/account-info'),
  respondPrice: (id, action) => api.post(`/customer/orders/${id}/respond-price`, { action }),
};

export const customerMessagesAPI = {
  getMessages: (orderId) => api.get(`/messages/customer/${orderId}`),
  sendMessage: (orderId, message) => api.post(`/messages/customer/${orderId}`, { message }),
  getUnreadAll: () => api.get('/messages/customer/unread-all'),
};

export default api;
